import { map } from 'lodash';
import { Folder } from 'common/xislivechat/models/folder';

export class FolderService {
  private gettingFoldersInProgress: Promise<any> = null;
  private folders: Folder[] = [];

  constructor(private bcRestApi, private folderType) {
  }

  public getFolders(): Promise<Folder[]> {
    if (this._isSendingInProgress()) {
      return this.gettingFoldersInProgress;
    }

    function FolderModelWrapper(item) {
      return new Folder(item);
    }

    this.gettingFoldersInProgress = this.bcRestApi.getFolders(this.folderType);

    return this.gettingFoldersInProgress.then(result => {
      this.folders = map(result, FolderModelWrapper);
      this.gettingFoldersInProgress = null;
      return this.folders;
    });
  }

  private _isSendingInProgress() {
    return !!this.gettingFoldersInProgress;
  }

  public getFolderName(folderId): Promise<string> {
    return new Promise(resolve => {
      let folderName = this._findFolderName(folderId);
      if (folderName) {
        resolve(folderName);
      } else {
        this.getFolders().then(() => {
          folderName = this._findFolderName(folderId);
          if (folderName) {
            resolve(folderName);
          } else {
            console.warn(`Folder does not exist for FolderID: ${folderId}`);
            resolve('');
          }
        });
      }
    });
  }

  private _findFolderName(folderId) {
    let folder = null;
    if (this.folders.length > 0) {
      folder = this.folders.find(element => String(element.id) === String(folderId));
    }
    return folder && folder.name ? folder.name : null;
  }
}
